import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Use useNavigate instead of useHistory

// Define the words to animate
const words = ['PVP', 'ONEBLOCK', 'BEDWARS', 'SURVIVAL'];

// Hero component
const Hero = () => {
    const [currentWord, setCurrentWord] = useState(words[0]);
    const [visible, setVisible] = useState(true); // Start visible
    const [showDialog, setShowDialog] = useState(false); // For dialog visibility
    const navigate = useNavigate(); // Initialize useNavigate

    useEffect(() => {
        const changeWord = () => {
            setVisible(false); // Fade out the current word
            setTimeout(() => {
                setCurrentWord((prev) => words[(words.indexOf(prev) + 1) % words.length]);
                setVisible(true); // Fade in the new word
            }, 500); // Duration for fade-out
        };

        const interval = setInterval(changeWord, 4500); // Change word every 4.5 seconds

        return () => clearInterval(interval);
    }, []);

    // Function to handle button click to open the server info dialog
    const handleAddServerClick = () => {
        setShowDialog(true);
    };

    // Function to handle closing the dialog
    const handleCloseDialog = () => {
        setShowDialog(false);
    };

    return (
        <div style={{
            backgroundImage: 'url(/heroimg.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
        }}>
            <img src="/logo.png" alt="Logo" style={{
                width: '300px', // Decrease logo size
                height: 'auto',
                marginBottom: '20px',
            }} />
            <h1 style={{
                color: 'white',
                fontWeight: 'bold',
                textAlign: 'center',
            }}>Free For All. All For Free</h1>
            <h2 style={{
                fontFamily: 'navbar-font', // Use the custom font
                background: 'linear-gradient(270deg, orange, red, orange, red)', // Animated gradient
                backgroundSize: '400% 400%',
                WebkitBackgroundClip: 'text', // For webkit browsers
                backgroundClip: 'text', // For other browsers
                color: 'transparent', // To show the gradient only
                fontWeight: 'bold',
                textAlign: 'center',
                marginTop: '10px',
                fontSize: '3rem', // Increase the font size of the words
                opacity: visible ? 1 : 0,
                transition: 'opacity 0.5s ease-in-out', // Fade effect
                animation: 'gradientAnimation 5s ease infinite', // Animation for gradient
                position: 'relative', // Ensure positioning context
                zIndex: 1, // Ensure it's above other elements
            }}>{currentWord}</h2>
            <button onClick={handleAddServerClick} style={{
                backgroundColor: 'yellow',
                color: 'black',
                border: 'none',
                borderRadius: '25px',
                padding: '10px 20px',
                fontSize: '1rem',
                fontWeight: 'bold', // Bold text
                cursor: 'pointer',
                textAlign: 'center',
                transition: 'background-color 0.3s',
                border: '2px solid transparent', // Transparent border
                marginTop: '20px',
            }}>
                Add Our Server
            </button>

            {/* Modal Dialog */}
            {showDialog && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                }}>
                    <div style={{
                        backgroundColor: '#fff',
                        padding: '0', // No padding around the Server Info header
                        borderRadius: '10px',
                        width: '400px',
                        textAlign: 'center',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    }}>
                        {/* Orange Server Info Header */}
                        <div style={{
                            backgroundColor: 'orange', // Orange background for "Server Info"
                            color: 'white', // White text for contrast
                            padding: '10px',
                            borderRadius: '10px 10px 0 0', // Rounded top corners touching the top of the dialog
                        }}>
                            <h3 style={{ margin: 0 }}>Server Info</h3>
                        </div>
                        <div style={{
                            padding: '20px', // Add padding to the content part
                        }}>
                            <p style={{ color: 'black' }}>IP: <strong>powergamesgg.aternos.me</strong></p>
                            <p style={{ color: 'black' }}>Port: <strong>36071</strong></p>
                            <p style={{ color: 'black' }}>OR</p> {/* "OR" on a separate line */}
                            <p style={{ color: 'black' }}>(For Java) <strong>powergamesgg.aternos.me:36071</strong></p>
                            <button onClick={handleCloseDialog} style={{
                                backgroundColor: 'red',
                                color: 'white',
                                border: 'none',
                                borderRadius: '15px',
                                padding: '10px 20px',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                marginTop: '20px',
                            }}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style>
                {`
                    @keyframes gradientAnimation {
                        0% {
                            background-position: 0% 50%;
                        }
                        50% {
                            background-position: 100% 50%;
                        }
                        100% {
                            background-position: 0% 50%;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default Hero;
